export default "__VITE_ASSET__CbFzWfv1__"